export default "__VITE_ASSET__CdRU6FpF__"